export enum SupportQueryType {
    question = 'question',
    errorReport = 'question',
    improvement = 'improvement'
}